import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
// import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons'
import { AdminService } from 'src/app/services/admin/admin.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  faEyeSlash = 'faEyeSlash';
  faEye = 'faEye';

  form: FormGroup;
  isLoading = false;
  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  passwordStrength = 0; // პაროლის სიძლიერის პროცენტი
  isTyping = false; // აკრეფისას პროგრესის გამოჩენა

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private adminService: AdminService,
    private translateService: TranslateService
  ) {
    this.form = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    // **პაროლის სიძლიერის გამოსათვლელად მონიტორინგი**
    this.form.get('newPassword')?.valueChanges.subscribe(value => {
      this.isTyping = value.length > 0;
      this.calculateStrength(value);
      this.form.get('confirmPassword')?.updateValueAndValidity();
    });
  }

  passwordMatchValidator(formGroup: FormGroup): ValidationErrors | null {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPasswordControl = formGroup.get('confirmPassword');

    if (!confirmPasswordControl) return null;

    if (confirmPasswordControl.errors && !confirmPasswordControl.errors['mismatch']) {
      return null;
    }

    if (newPassword !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      confirmPasswordControl.setErrors(null);
      return null;
    }
  }

  calculateStrength(password: string) {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/\d/.test(password)) strength++;

    this.passwordStrength = (strength / 4) * 100;
  }

  changePassword(): void {
    if (this.form.invalid) {
      return;
    }
  
    this.isLoading = true;
    const { oldPassword, newPassword, confirmPassword } = this.form.value;
  
    // API მოთხოვნაში დამატებულია `newPassword_confirmation`
    this.adminService.changePassword({ 
      oldPassword, 
      newPassword, 
      newPassword_confirmation: confirmPassword 
    }).subscribe(
      (response: any) => {
        this.toastr.success(this.translateService.instant('PASSWORD_CHANGED_SUCCESS'));
        this.isLoading = false;
        this.form.reset();
        this.isTyping = false; 
      },
      (error: any) => {
        // console.error('Error:', error);

        const errorMessage = error?.error?.errors?.newPassword?.[0] || 
                              this.translateService.instant('ERROR_CHANGE_PASSWORD');
      
        this.toastr.error(errorMessage);
        this.isLoading = false;
      }
    );
  }

  toggleShowPassword(field: string): void {
    if (field === 'oldPassword') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'newPassword') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirmPassword') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
}